import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private readonly loadingMessageSubject = new BehaviorSubject<string>("");
  public loadingMessage$ = this.loadingMessageSubject.asObservable();

  // Reference counter to track active requests
  private activeRequests = 0;

  show(): void {
    this.activeRequests++;
    // Only show loader on first request
    if (this.activeRequests === 1) {
      this.loadingSubject.next(true);
    }
  }

  hide(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    // Only hide loader when all requests are complete
    if (this.activeRequests === 0) {
      this.loadingSubject.next(false);
      this.loadingMessageSubject.next("");
    }
  }

  setMessage(message: string): void {
    this.loadingMessageSubject.next(message);
  }

  clearMessage(): void {
    this.loadingMessageSubject.next("");
  }
}
